import { HeroSection } from "./HeroSection";
import { FeaturesSection } from "./FeaturesSection";
import { WhySection } from "./WhySection";
import { VideoSection } from "./VideoSection";
import { TestimonialsSection } from "./TestimonialsSection";
import { FaqSection } from "./FaqSection";
import { WaitlistSection } from "./WaitlistSection";
import { LandingFooter } from "./LandingFooter";
import { LandingNav } from "./LandingNav";
import { useDemoData } from "../hooks/useDemoData";
import { useScrollDepth } from "../hooks/useScrollDepth";

interface LandingPageProps {
  readonly isDark: boolean;
  readonly onToggleTheme: () => void;
}

export function LandingPage({ isDark, onToggleTheme }: LandingPageProps) {
  const demo = useDemoData();
  useScrollDepth();

  return (
    <div className="min-h-screen bg-surface text-ink antialiased overflow-x-hidden">
      <LandingNav isDark={isDark} onToggleTheme={onToggleTheme} />
      <HeroSection todayEvents={demo.todayEvents} doingTasks={demo.doingTasks} />
      <FeaturesSection demo={demo} />
      <VideoSection />
      <WhySection />
      <TestimonialsSection />
      <FaqSection />
      <WaitlistSection />
      <LandingFooter />
    </div>
  );
}
